import Box from "@mui/material/Box";
import React, {useEffect, useState} from "react";
import Container from "react-bootstrap/Container";
import {TICKET_CATEGORIES_URL} from "../../../Constants/Constants";
import AxiosInstance from "../../../services/AxiosInstance";
import AppTableView from "../../AppTableView";
import CategoryDialog from "./CategoryDialog";

function Categories() {

  const [data, setData] = useState([]);

  useEffect(() => {
    getCategories();
  }, []);

  const getCategories = () => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(TICKET_CATEGORIES_URL).then((response) =>
      setData(response.data.data)
    );
  };

  return (
    <Container fluid style={{ display: "flex", flexDirection: "column" }}>
      <Box>
        <CategoryDialog
          editCategoryId={""}
          selectedCategoryId={""}
          categoryName={""}
          callCategories={getCategories}
          isEdit={false}
        />
      </Box>
      <AppTableView
        rows={data}
        cols={[
          {
            field: "name",
            headerName: "Category",
            flex: 1,
            renderCell: (params) => (
              <CategoryDialog
                editCategoryId={params.row.id}
                selectedCategoryId={params.row.id}
                categoryName={params.row.name}
                callCategories={getCategories}
                isEdit={true}
              />
            ),
          },
          {
            field: "active",
            headerName: "Active",
            flex: 1,
            renderCell: (params) => (params.value ? "Yes" : "No"),
          },
        ]}
        initialPageSize={15}
      />
    </Container>
  );
}

export default Categories;
